<template>
  <div class="container testimonials" id="testimonials">
    <div class="content-heading is-flex">
      <h3 class="is-size-3">Accommodations</h3>
      <router-link to="/admin/accommodations/new" class="button is-info">Add New</router-link>
    </div>

    <transition mode="out-in" name="fade">
      <modal @close="showModal = false" :kind="kind" v-if="showModal" :header="header"/>
    </transition>

    <router-view></router-view>

    <div class="box">
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th>
              Name
            </th>
            <th>
              Property
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(accommodation, index) in accommodations" :key="index">
            <td>
              <p>
                <router-link :to="'/admin/accommodations/edit/' + accommodation['.key']">
                  {{accommodation.name}}
                </router-link>
              </p>
            </td>
            <td>
              {{accommodation.property}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- notification -->
    <transition mode="out-in" name="fade">
      <div v-if="notification.message" :class="'notification is-' + notification.type">
        <button class="delete" @click="hideNotifications"></button>{{notification.message}}
      </div>
    </transition>
  </div>
</template>

<script>
// import firebase from 'firebase'
import { accommodationsRef } from '@/firebase_config'
import modal from '@/components/shared/Modal'
import notifier from '@/mixins/notifier'

export default {
  name: 'accommodations',
  data () {
    return {
      showModal: false,
      header: '',
      kind: '',
      accommodation: null,
      sortKey: 'title'
    }
  },
  firebase: {
    accommodations: accommodationsRef
  },
  mixins: [notifier],
  computed: {},
  methods: {},
  components: {
    modal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/content/Accommodations.vue